import React from 'react';

import ColorSwatch from '../../../../components/color-swatch/ColorSwatch';
import ToggleSwitch from '../../../../components/toggle-switch/ToggleSwitch';

import scss from './ColorField.module.scss';

function ColorField({ label, value, enabled = true, onToggle, onChange, onDone }) {
  return (
    <div className={scss.fieldRow}>
      <span>{label}</span>
      {enabled ? <ColorSwatch value={value} title={label} onChange={onChange} onDone={onDone} /> : null}
      {onToggle ? <ToggleSwitch checked={enabled} label={label} onChange={onToggle} /> : null}
    </div>
  );
}

export default ColorField;
